import React, { useState } from "react";
import { Link } from "react-router-dom";

import MuiSwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { styled } from "@mui/material/styles";

import profileIcon from "../img/circular-profile-icon.svg";
import homeIcon from "../img/circular-home-icon.svg";
import honeycombIcon from "../img/circular-honeycomb-icon.svg";
import dropBuyIcon from '../img/dropBuyIcon.svg';
import adminIcon from "../img/circular-admin-tools-icon.svg";
import hexaBgDrawer from "../img/hexa-bg-drawer.svg";
import menuIcon from "../img/icons/menu.svg";
import honeypotIcon from '../img/icons/honeypot-icon.svg'
import swarmAdminIcon from '../img/swarm-admin-icon.svg'
import swarmBeeIcon from '../img/icons/circular-swarm-icon.svg'
import { Box, Button } from "@mui/material";
import { UserType } from "../constants/enums";
import AllowedAccess from "./AllowedAccess";

export default function MainDrawerMobile({
  user,
  drawerState,
  setDrawerState,
  openTermsAndCondtions,
}) {
  const menuLinks = [
    {
      "text": "My Hive",
      "icon": (
        <img 
          src={homeIcon} 
          alt="Profile Icon" 
          height="64px" 
          width="64px" 
        />
      ),
      "link": "/dashboard/home"
    },
    {
      text: "Swarms",
      icon: (
        <img src={swarmBeeIcon} alt="Honeycomb Icon" height="64px" width="64px" />
      ),
      link: "/dashboard/swarms",
    },
    {
      text: "Honeycomb",
      icon: (
        <img src={honeycombIcon} alt="Honeycomb Icon" height="64px" width="64px" />
      ),
      link: "/dashboard/jobs",
    },
    {
      text: "DropBuy",
      icon: (
        <img
          src={dropBuyIcon}
          alt="Profile Icon"
          height="64px"
          width="64px"
          className="icon-dashboard"
        />
      ),
      link: "/dashboard/DropBuy",
    },
    {
      text: "Resources",
      icon: (
        <img
          src={menuIcon}
          alt="Resources Icon"
          height="64px"
          width="64px"
          className="icon-dashboard"
        />
      ),
      link: "/dashboard/resources",
    }
  ];

  const MenuAdmin = () => {
    return (
      <div className="side-bar-admin">
        <ListItem button key={adminIcon} style={{ padding:'0 16px', margin:'0' }} >
          <ListItemText className="item-dashboard  d-grid">
            <Link to="/dashboard/admintools" className="link-sidebar">

              <img
                src={adminIcon}
                alt="Profile Icon"
                height="64px"
                width="64px"
                className="icon-dashboard"
              />
              <p style={{ margin: "0 0 0 0.5em", fontSize: "1.25rem" }}>Admin Tools</p>
            </Link>
          </ListItemText>
        </ListItem>
      </div>
    );
  };

  const SwarmAdmin = () => {
    return (
      <div>
        <ListItem button key={adminIcon} style={{ padding:'0 16px', margin:'0 0 2em 0' }} >
          <ListItemText className="item-dashboard">
            <Link to="/dashboard/adminswarm" className="link-sidebar">
              <img
                src={swarmAdminIcon}
                alt="Profile Icon"
                height="64px"
                width="64px"
                className="icon-dashboard"
              />

              <p style={{ margin: "0 0 0 0.5em", fontSize: "1.25rem" }}>Swarm Admin</p>
            </Link>
          </ListItemText>
        </ListItem>
      </div>
    );
  };

  const PrivacyPolicy = () => {
    return (
      <div className="drawer-privacy-policy" >
        <Button
          href="https://www.encorehive.com/privacy-policy"
          target="_blank" rel="noreferrer"
          sx={{ color: "#ffbd00" }}
        >
          Privacy Policy
        </Button>
      </div>
    );
  };

  const TermsConditions = () => {
    const [openModal, setOpenModal] = useState(false);
    return (
      <div className="drawer-privacy-policy" >
        <Button
          onClick={openTermsAndCondtions}
          target="_blank" rel="noreferrer"
          sx={{ color: "#ffbd00" }}
        >
          Terms & Conditions
        </Button>        
      </div>
    );
  };

  const SwipeableDrawer = styled(MuiSwipeableDrawer)({

    '& .MuiDrawer-paper': {
      backgroundColor: "var(--greyblue)",
      backgroundImage: `url(${hexaBgDrawer})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "bottom, center",
      backgroundSize: "400px",
      zIndex: '0',
    }

  });

  const toggleDrawer = (setDrawerState, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setDrawerState(open);
  };

  return (
    <SwipeableDrawer
      anchor={"left"}
      open={drawerState}
      onOpen={toggleDrawer(setDrawerState, true)}
      onClose={toggleDrawer(setDrawerState, false)}
      sx={{ zIndex: 2 }}

    >
      <Box
        role="presentation"
        onClick={toggleDrawer(setDrawerState, false)}
        onKeyDown={toggleDrawer(setDrawerState, false)}
      >
        <div
         style={{
          height:"100vh",
          display:"flex",
          flexDirection: "column",
          justifyContent: "space-between",          
        }}
        >
          <div className="side-bar-buttons" style={{ margin: "5em 0 0 0" }}>
            {menuLinks.map((Icon, index) => {
              
              if(user.role !== "Admin" && !user.userDistribution && Icon.link === "/dashboard/DropBuy") return null
              if(user.role !== "Admin" && !user.userDistribution && Icon.link === "/dashboard/resources") return null
              
              return(
                <ListItem button key={Icon.link} style={{ padding:'0 16px' }} >
                  <ListItemText className="item-dashboard">
                    <Link to={Icon.link} className="link-sidebar">

                      {Icon.icon}

                      <p style={{ margin: "0 0 0 0.5em", fontSize: "1.25rem" }}>
                        {Icon.text}
                      </p>
                    </Link>
                  </ListItemText>
                </ListItem>
              )
            })}
          </div>

          <div>
            <AllowedAccess roles={["Admin"]}>
              <MenuAdmin />

              <AllowedAccess notAllow={true} userTypes={[UserType.HiveAdmin]}>
                <SwarmAdmin />
              </AllowedAccess>
            </AllowedAccess>
            
            <PrivacyPolicy />
            <TermsConditions/>
          </div>
        </div>
      </Box>
    </SwipeableDrawer>
  );
}
